import { z } from 'zod';

export const SplitsErrors = z.object({
  splits: z.string().nullish(),
});

export type SplitsErrors = (typeof SplitsErrors)['_input'];
